var watchlistDelete = {
	title: "Eliminar lista de seguimiento",
	nameInputLabel: "Nombre de la lista de seguimiento",
	alertHeading: "Está seguro de que desea eliminar la lista de seguimiento",
	alertBody: "En caso afirmativo, haga clic en eliminar. Tenga en cuenta que las listas de seguimiento eliminadas no se pueden restaurar.",
	confirmBtn: "Ok",
	cancelBtn: "Cancelar"
};
var es = {
	watchlistDelete: watchlistDelete
};

export { es as default, watchlistDelete };
